"use client";

import {
  Box,
  Button,
  Flex,
  Text,
  Input,
  Spinner,
  FormControl,
  FormLabel,
  Switch,
  useToast,
  NumberInput,
  NumberInputField,
} from "@chakra-ui/react";
import { useState } from "react";
import { useUploadFluxLora } from "queries";

const LoraUpload = () => {
  const [file, setFile] = useState<File | null>(null);
  const [fileName, setFileName] = useState<string>("");
  const [title, setTitle] = useState<string>("");
  const [triggerWords, setTriggerWords] = useState<string>("");
  const [imageBlob, setImageBlob] = useState<File | null>(null);
  const [downloadCount, setDownloadCount] = useState<number>(0);
  const [isNsfw, setIsNsfw] = useState<boolean>(false);

  const toast = useToast();
  const uploadFluxLoraMutation = useUploadFluxLora();

  // Handle form submission
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!title || !imageBlob) {
      toast({
        title: "Missing Required Fields",
        description: "Title and Image Blob are required.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    // Show toast immediately after clicking upload
    toast({
      title: "Lora Upload Initiated",
      description: "Lora will be added soon. Please wait...",
      status: "info",
      duration: 3000,
      isClosable: true,
    });

    uploadFluxLoraMutation.mutate({
      file,
      fileName: file ? file.name : fileName || undefined,
      title,
      trigger_words: triggerWords,
      image_blob_name: imageBlob,
      download_count: downloadCount,
      is_nsfw: isNsfw,
    });
  };

  return (
    <Flex direction="column" align="center" mt={10}>
      <Box bg="black" p={6} borderRadius="8px" boxShadow="lg" w="400px">
        <Text fontSize="2xl" mb={4} fontWeight="bold" textAlign="center">
          Upload Flux Lora
        </Text>

        <form onSubmit={handleSubmit}>
          {/* Lora File Upload */}
          <FormControl mb={4}>
            <Text fontWeight="semibold" mb={2}>Upload Lora File (.safetensors)</Text>
            <Input
              type="file"
              onChange={(e) => setFile(e.target.files?.[0] || null)}
            />
          </FormControl>

          {/* File Name Input */}
          <FormControl mb={4}>
            <Text fontWeight="semibold" mb={2}>File Name</Text>
            <Input
              placeholder="Enter file name"
              value={fileName}
              onChange={(e) => setFileName(e.target.value)}
            />
          </FormControl>

          {/* Title Input */}
          <FormControl mb={4} isRequired>
            <Text fontWeight="semibold" mb={2}>Lora Title</Text>
            <Input
              placeholder="Enter title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </FormControl>

          {/* Trigger Words Input */}
          <FormControl mb={4}>
            <Text fontWeight="semibold" mb={2}>Trigger Words</Text>
            <Input
              placeholder="Enter trigger words"
              value={triggerWords}
              onChange={(e) => setTriggerWords(e.target.value)}
            />
          </FormControl>

          {/* Image Blob Upload */}
          <FormControl mb={4} isRequired>
            <Text fontWeight="semibold" mb={2}>Upload Image (Blob)</Text>
            <Input
              type="file"
              accept="image/*"
              onChange={(e) => setImageBlob(e.target.files?.[0] || null)}
            />
          </FormControl>

          {/* Download Count Input */}
          <FormControl mb={4}>
            <Text fontWeight="semibold" mb={2}>Download Count</Text>
            <NumberInput
              min={0}
              value={downloadCount}
              onChange={(value) => setDownloadCount(Number(value))}
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>

          {/* NSFW Switch */}
          <FormControl display="flex" alignItems="center" mb={4}>
            <Text fontWeight="semibold" mr={4}>NSFW Content</Text>
            <Switch isChecked={isNsfw} onChange={() => setIsNsfw(!isNsfw)} />
          </FormControl>

          {/* Submit Button */}
          <Button
            type="submit"
            colorScheme="blue"
            width="100%"
            isLoading={uploadFluxLoraMutation.isPending}
          >
            Upload Lora
          </Button>

          {/* Success & Error Feedback */}
          {uploadFluxLoraMutation.isSuccess && (
            <Text mt={4} color="green.500" textAlign="center">
              Lora uploaded successfully! ID: {uploadFluxLoraMutation.data?.lora_id}
            </Text>
          )}

          {uploadFluxLoraMutation.isError && (
            <Text mt={4} color="red.500" textAlign="center">
              Error uploading Lora. Please try again.
            </Text>
          )}
        </form>
      </Box>
    </Flex>
  );
};

export default LoraUpload;





/* import React, { useState } from 'react';
import { useDeleteLora, useGetAdminLoras, useScrapeLoraData, useUploadLora, useUploadFluxLora } from 'queries';
import { 
  Modal, 
  ModalOverlay, 
  ModalContent, 
  ModalHeader, 
  ModalFooter, 
  ModalBody, 
  ModalCloseButton,
  Button, 
  Input, 
  VStack,
  InputGroup,
  InputRightElement,
  Box, 
  Image,
  Text,
  FormControl,
  FormLabel,
  useToast,
  Checkbox,
  Radio,
  RadioGroup,
  Stack,
  Grid,
  Heading,
  Spinner,
  Container
} from '@chakra-ui/react';

export const LoraUpload: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [civitAiUrl, setCivitAiUrl] = useState('');
  const [keywords, setKeywords] = useState('');
  const [title, setTitle] = useState('');
  const [image, setImage] = useState<File | null>(null);
  const [imagePreview, setImagePreview] = useState<string | null>(null);
  const [imageUrl, setImageUrl] = useState('');
  const [loraFile, setLoraFile] = useState<File | null>(null);
  const [loraFileName, setLoraFileName] = useState('');
  const [uploadType, setUploadType] = useState<'file' | 'fileName'>('file');
  const [downloadCount, setDownloadCount] = useState<number>(0);
  const [isNSFW, setIsNSFW] = useState(false);
  const [isFluxLora, setIsFluxLora] = useState(false);

  const { data: adminLorasData, isLoading: isLoadingLoras, isError: isErrorLoras, error: lorasError } = useGetAdminLoras();
  const uploadLoraMutation = useUploadLora();
  const uploadFluxLoraMutation = useUploadFluxLora();
  const deleteLoraMutation = useDeleteLora();

  const { mutate: scrapeData } = useScrapeLoraData();
  const toast = useToast();

  const handleScrape = () => {
    scrapeData({ url: civitAiUrl }, {
      onSuccess: (data) => {
        setKeywords(data.trigger_words.join(', '));
        setTitle(data.title);
        setImageUrl(data.image_url);
        setDownloadCount(data.download_count || 0);  
      },
      onError: (error) => {
        console.error("Error scraping data:", error);
        toast({
          title: "Error scraping data",
          description: error.message,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    });
  };

  const handleDelete = (loraId: string) => {
    deleteLoraMutation.mutate(loraId, {
      onSuccess: () => {
        toast({
          title: "Lora deleted successfully",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      },
      onError: (error) => {
        toast({
          title: "Error deleting Lora",
          description: error.message,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    });
  };

  const handleUpload = () => {
    if ((uploadType === 'file' && loraFile) || (uploadType === 'fileName' && loraFileName) && title && imageUrl) {
      const uploadData = {
        file: uploadType === 'file' ? loraFile : undefined,
        fileName: uploadType === 'fileName' ? loraFileName : undefined,
        title: title,
        trigger_words: keywords,
        image_url: imageUrl,
        download_count: downloadCount,
        is_nsfw: isNSFW
      };

      const mutation = isFluxLora ? uploadFluxLoraMutation : uploadLoraMutation;

      mutation.mutate(uploadData, {
        onSuccess: (data) => {
          toast({
            title: `${isFluxLora ? 'Flux Lora' : 'Lora'} uploaded successfully`,
            description: `ID: ${data.lora_id}`,
            status: "success",
            duration: 5000,
            isClosable: true,
          });
          setIsModalOpen(false);
        },
        onError: (error) => {
          toast({
            title: `Error uploading ${isFluxLora ? 'Flux Lora' : 'Lora'}`,
            description: error.message,
            status: "error",
            duration: 5000,
            isClosable: true,
          });
        }
      });
    } else {
      toast({
        title: "Missing information",
        description: "Please fill all required fields, select a Lora file or provide a file name, and provide an image URL.",
        status: "warning",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setImage(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  return (
    <>
      <Button onClick={() => setIsModalOpen(true)}>Upload Lora</Button>

      <Modal isCentered isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader color="black">Upload Lora</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack spacing={4}>
              <InputGroup>
                <Input
                  color="black"
                  value={civitAiUrl}
                  onChange={(e) => setCivitAiUrl(e.target.value)}
                  placeholder="Civit AI URL"
                />
                <InputRightElement width="4.5rem">
                  <Button h="1.75rem" size="sm" onClick={handleScrape}>
                    Scrape
                  </Button>
                </InputRightElement>
              </InputGroup>

              <FormControl>
                <FormLabel color="black">Keywords (Optional)</FormLabel>
                <Input
                  color="black"
                  value={keywords}
                  onChange={(e) => setKeywords(e.target.value)}
                  placeholder="Keywords"
                />
              </FormControl>

              <Input
                color="black"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="Title"
              />

              <FormControl>
                <FormLabel color="black">Download Count</FormLabel>
                <Input
                  color="black"
                  type="number"
                  value={downloadCount}
                  onChange={(e) => setDownloadCount(Number(e.target.value))}
                  placeholder="Download Count"
                />
              </FormControl>

              <FormControl>
                <FormLabel color="black">Image URL</FormLabel>
                <Input
                  color="black"
                  value={imageUrl}
                  onChange={(e) => setImageUrl(e.target.value)}
                  placeholder="Image URL"
                />
                {imageUrl && (
                  <Box boxSize="200px" mt={2}>
                    <Image src={imageUrl} alt="Preview" objectFit="cover" />
                  </Box>
                )}
              </FormControl>

              <FormControl>
                <FormLabel color="black">Lora File</FormLabel>
                <RadioGroup color="black" onChange={(value) => setUploadType(value as 'file' | 'fileName')} value={uploadType}>
                  <Stack direction="row">
                    <Radio color="black" value="file">Upload File</Radio>
                    <Radio color="black" value="fileName">Use Existing File Name</Radio>
                  </Stack>
                </RadioGroup>
                {uploadType === 'file' ? (
                  <Input
                    type="file"
                    onChange={(e) => setLoraFile(e.target.files?.[0] || null)}
                    accept=".safetensors,.ckpt,.pt"
                  />
                ) : (
                  <Input
                    color="black"
                    value={loraFileName}
                    onChange={(e) => setLoraFileName(e.target.value)}
                    placeholder="Enter existing file name"
                  />
                )}
                {loraFile && uploadType === 'file' && (
                  <Text color="green.500">Lora file selected: {loraFile.name}</Text>
                )}
              </FormControl>

              <FormControl>
                <Stack spacing={3}>
                  <Checkbox
                    isChecked={isNSFW}
                    onChange={(e) => setIsNSFW(e.target.checked)}
                    colorScheme="red"
                  >
                    <Text color="black">This Lora is NSFW (Not Safe For Work)</Text>
                  </Checkbox>
                  <Checkbox
                    isChecked={isFluxLora}
                    onChange={(e) => setIsFluxLora(e.target.checked)}
                    colorScheme="blue"
                  >
                    <Text color="black">This is a Flux Lora</Text>
                  </Checkbox>
                </Stack>
              </FormControl>
            </VStack>
          </ModalBody>

          <ModalFooter>
            <Button 
              colorScheme="blue" 
              mr={3} 
              onClick={handleUpload} 
              isLoading={uploadLoraMutation.isPending || uploadFluxLoraMutation.isPending}
              loadingText="Uploading..."
            >
              Upload
            </Button>
            <Button variant="ghost" onClick={() => setIsModalOpen(false)}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Box mt={8}>
        <Heading size="lg" mb={4}>Existing Loras</Heading>
        {isLoadingLoras ? (
          <Container centerContent>
            <Spinner size="xl" />
            <Text mt={4}>Loading Loras...</Text>
          </Container>
        ) : isErrorLoras ? (
          <Container centerContent>
            <Text color="red.500">Error loading Loras: {lorasError?.message}</Text>
          </Container>
        ) : (
          <Grid templateColumns="repeat(auto-fill, minmax(200px, 1fr))" gap={6}>
            {adminLorasData?.loras.map((lora: any) => (
              <VStack key={lora.id} borderWidth={1} borderRadius="lg" p={4} align="stretch">
                <Image 
                  src={lora.image_url} 
                  alt={lora.name} 
                  objectFit="cover" 
                  height="200px"
                  fallbackSrc="https://via.placeholder.com/200"
                />
                <Text fontWeight="bold" isTruncated>{lora.name}</Text>
                <Text fontSize="sm" color="gray.500" isTruncated>{lora.title}</Text>
                {lora.is_nsfw && <Text color="red.500" fontSize="xs">NSFW</Text>}
                <Button
                  colorScheme="red"
                  size="sm"
                  onClick={() => handleDelete(lora.id)}
                  isLoading={deleteLoraMutation.isPending && deleteLoraMutation.variables === lora.id}
                  loadingText="Deleting..."
                >
                  Delete
                </Button>
              </VStack>
            ))}
          </Grid>
        )}
      </Box>
    </>
  );
}; 
*/

